import React from 'react';

// Material Ui
import { Box, Alert } from '@mui/material';
// Custom Ui
import { useNavigate } from 'react-router';
import { connect } from 'react-redux';
import Logo from '../../components/UI/Logo';

// Redux
import * as userActions from '../../store/actions/user'; // May need teacher-specific actions
import { StyledBox, StyledGrid, StyledImageSection, StyledLoginSection } from './Login.styles';
import LoginTeacher from '../../components/Auth/LoginTeacher';

export function TeacherLogin(props) {
	const navigate = useNavigate();

	const onRegisterClick = (e) => {
		props.updateUserError(null);
		navigate('/register/profesor');
	};

	const onResetPasswordClick = (e) => {
		props.updateUserError(null);
		navigate('/reset-password');
	};

	return (
		<StyledGrid container>
			<StyledImageSection item xs={12} sm={12} md={7} isteacher={'true'}></StyledImageSection>
			<StyledLoginSection item xs={12} sm={12} md={5}>
				<Box
					display="flex"
					flexDirection="column"
					height="100%"
					alignItems="left"
					justifyContent="center"
				>
					<StyledBox>
						{props.statusMessage ? <Alert severity={error}>{props.statusMessage}</Alert> : null}
						<Logo cancelRedirect={true} height="100px" />
						<LoginTeacher
							onResetPasswordClick={onResetPasswordClick}
							onRegisterClick={onRegisterClick}
							onLoginClick={() => {}}
							error={props.error}
							updateError={props.updateUserError}
							updateUserStatus={props.updateUserStatus}
							isStatusMessage={!!props.statusMessage}
						/>
					</StyledBox>
				</Box>
			</StyledLoginSection>
		</StyledGrid>
	);
}

const mapStateToProps = (state) => ({
	error: state.user.error,
	user: state.user.credentials,
	statusMessage: state.user.statusMessage
});

const mapDispatchToProps = {
	loginUser: userActions.loginUser,
	registerUser: userActions.registerUser,
	generateResetPassword: userActions.generateResetPassword,
	resetPassword: userActions.resetPassword,
	updateUserError: userActions.updateUserError,
	updateUserStatus: userActions.updateUserStatus,
	verifyEmail: userActions.verifyEmail
};

export default connect(mapStateToProps, mapDispatchToProps)(TeacherLogin);
